import { DevicesStatusTable } from "./devicesStatusTable";
import { getDeviceStatus } from "../../utilities/getDeviceStatus";
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { EmptyState } from "./emptyState";
import Loader from "../shared/loader";
import arrayUtilities from '../../utilities/arrayUtilities';
import Enums from '../../utilities/enum';
import Enum from "../../utilities/enum";
import { DeviceStatusScheduleModal } from "../reports/schedule-modals/deviceStatusScheduleModal";
export const DeviceStatus = (props) => {
    const [filteredDevices, setFilteredDevices] = useState([]);
    const [showScheduleExportModal, setShowScheduleExportModal] = useState(false);

    const closeScheduleExportModal = () => setShowScheduleExportModal(false)

    useEffect(() => {
        if (props.orderedDevices) {
            const temp = props.orderedDevices.map(item => {
                const deviceStatus = getDeviceStatus(item, props.deviceType, props.warningThreshold, props.dangerThreshold);
                return {
                    filteredDevice: item,
                    status: deviceStatus.status,
                    pillButton: deviceStatus.statusPillButton
                }
            })
            if (!props.viewAll) {
                setFilteredDevices(temp.filter(item => item.status < 3))
            }
            else if (props.viewAll) {
                setFilteredDevices(temp);
            }
        }
    }, [props.orderedDevices, props.viewAll]);

    return (
        <div className="card">
            <div className="card-header">
                <div className="row align-items-center justify-content-between px-2">
                    <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">{props.deviceType} Status</h5>
                    <div className="d-flex">
                        <button
                            onClick={props.handleRefreshClick}
                            className="btn btn-falcon-default btn-sm d-flex align-items-center"
                        >
                            Refresh
                            <i className="fas fa-sync d-flex align-items-center ml-2"></i>
                        </button>
                        {props.handleExport && <button onClick={() => props.handleExport()} className="btn btn-primary btn-sm ml-2">Export<i className="ml-2 fas fa-download"></i></button>}
                        {
                            props.deviceType === Enum.DeviceType[0]
                            && <button
                                onClick={ () => setShowScheduleExportModal(true) }
                                className="btn btn-sm btn-secondary nowrap ml-1"
                            >
                                Schedule Report<i className="ml-2 far fa-clock"></i>
                            </button>
                        }
                        <Link to={props.viewAllUrl ?? '/'}>
                            <button className="btn btn-falcon-default btn-sm ml-2 d-flex align-items-center">
                                {
                                    props.viewAllUrl
                                        ? <span>View All<i className="ml-2 fas fa-chevron-right"></i></span>
                                        : <span><i className="fas fa-chevron-left mr-2"></i>Back to Dashboard</span>
                                }
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            {
                props.isLoading ? (<Loader />)
                    : arrayUtilities.isNullOrEmpty(props.orderedDevices)
                        ? (<EmptyState iconClass="fas fa-question fa-7x" iconColor="#c9c9c9" />)
                        : (
                            !arrayUtilities.isNullOrEmpty(filteredDevices)
                                ? (
                                    <div className="card-body bg-light border-top details-container p-0">
                                        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
                                            <thead className="bg-200 text-900">
                                                <tr>
                                                    {
                                                        props.deviceType === Enums.DeviceType[0] &&
                                                        <th className="text-nowrap">Last Image</th>
                                                    }
                                                    <th>{props.deviceType} Name</th>
                                                    <th>Site Name</th>
                                                    {
                                                        props.deviceType === Enums.DeviceType[0] &&
                                                        <th className="text-center">Active</th>
                                                    }
                                                    <th className="text-center">Last Heartbeat</th>
                                                    {
                                                        props.viewAll && props.deviceType === "Kiosk" &&
                                                        <th>&nbsp;</th>
                                                    }
                                                </tr>
                                            </thead>
                                            {
                                                <DevicesStatusTable
                                                    deviceType={props.deviceType}
                                                    filteredDevices={filteredDevices}
                                                    organisationId={props.organisationId}
                                                    viewAll={props.viewAll}
                                                    handleDelete={id => props.handleDelete(id)}
                                                />
                                            }
                                        </table>
                                        <div className="d-flex justify-content-center row align-items-center pt-2">
                                            <div className="col-auto align-items-center">
                                                <div className="row justify-content-center showing-items">
                                                    Showing {filteredDevices.length.toLocaleString()} items
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                                : (
                                    <EmptyState
                                        iconClass="fas fa-check-circle fa-7x"
                                        iconColor="#28a745"
                                    />
                                )
                        )
            }

            {
                showScheduleExportModal &&
                <DeviceStatusScheduleModal
                    organisationId={ props.organisationId }
                    token={ props.token }
                    onCancel={ closeScheduleExportModal }
                    onSaved={ closeScheduleExportModal }
                />
            }
        </div>
    )
}